module.exports = __webpack_public_path__ + "static/media/01_tree_middle.adc5b64d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/street/01_tree_middle.png
// module id = 458
// module chunks = 0